import React from 'react';

const LoadingSpinner = () => <div style={{ textAlign: 'center' }}>Loading...</div>; // Add CSS spinner later

export default LoadingSpinner;